import { Button, Modal, ModalProps } from "@arco-design/web-react";

interface IRemoveTipModal extends ModalProps {
  handleHiddenDeleteBtnClick?: () => void;
  handleDeleteBtnClick: () => void;
  container?: string;
  isClearDelete?: boolean;
}

const RemoveTipModal: React.FC<IRemoveTipModal> = (props) => {
  const {
    handleDeleteBtnClick,
    handleHiddenDeleteBtnClick,
    container,
    isClearDelete,
    ...res
  } = props;
  return (
    <Modal
      {...res}
      className={`${res.className} vl-modal`}
      footer={
        <>
          <Button
            type="text"
            onClick={() => {
              handleDeleteBtnClick();
            }}
            loading={props.confirmLoading}
          >
            {props.cancelText || "彻底删除"}
          </Button>
          {isClearDelete ? (
            <></>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                handleHiddenDeleteBtnClick();
              }}
              loading={props.confirmLoading}
            >
              {props.okText || "放回收站"}
            </Button>
          )}
        </>
      }>
      {container
        ? container
        : "确认删除文件夹以下及其所有内容？ 删除后可在回收站有效期15天内恢复数据"}
    </Modal>
  );
};
export default RemoveTipModal;
